export class IOptionType {
    onPrevChangeView = (zoneID, isOutdoor, modelName) => { }
    onPostChangeView = (zoneID, isOutdoor, modelName) => { }
    onLoadingComplete = (zoneID, isOutdoor, modelName) => { }
    onPrevMouseMove = (event) => { }
    onPostMouseMove = (event) => { }
    onPrevClick = (event) => { }
    onPostClick = (event) => { }
}